import { captureException } from "@sentry/react";

type ErrorKind = "server_error" | "auth_denied" | "network_failure";

export function reportToSentry(
  error: Error,
  context: {
    url: string;
    method: string;
    service: string;
    kind: ErrorKind;
    status?: number;
  }
): void {
  captureException(error, {
    tags: {
      module: "network",
      service: context.service,
      kind: context.kind,
      ...(context.status !== undefined && { status: String(context.status) }),
    },
    extra: { url: context.url, method: context.method },
  });
}
